/** As 27 unidades da federação. Usada em endereço e em base territorial. */
export const UFS = [
  { sigla: "AC", nome: "Acre" }, { sigla: "AL", nome: "Alagoas" },
  { sigla: "AP", nome: "Amapá" }, { sigla: "AM", nome: "Amazonas" },
  { sigla: "BA", nome: "Bahia" }, { sigla: "CE", nome: "Ceará" },
  { sigla: "DF", nome: "Distrito Federal" }, { sigla: "ES", nome: "Espírito Santo" },
  { sigla: "GO", nome: "Goiás" }, { sigla: "MA", nome: "Maranhão" },
  { sigla: "MT", nome: "Mato Grosso" }, { sigla: "MS", nome: "Mato Grosso do Sul" },
  { sigla: "MG", nome: "Minas Gerais" }, { sigla: "PA", nome: "Pará" },
  { sigla: "PB", nome: "Paraíba" }, { sigla: "PR", nome: "Paraná" },
  { sigla: "PE", nome: "Pernambuco" }, { sigla: "PI", nome: "Piauí" },
  { sigla: "RJ", nome: "Rio de Janeiro" }, { sigla: "RN", nome: "Rio Grande do Norte" },
  { sigla: "RS", nome: "Rio Grande do Sul" }, { sigla: "RO", nome: "Rondônia" },
  { sigla: "RR", nome: "Roraima" }, { sigla: "SC", nome: "Santa Catarina" },
  { sigla: "SP", nome: "São Paulo" }, { sigla: "SE", nome: "Sergipe" },
  { sigla: "TO", nome: "Tocantins" },
] as const;

/**
 * Raça e cor pela tabela 11 do eSocial, que segue a classificação do IBGE.
 * É campo OBRIGATÓRIO do S-2200 e não existe em planilha de implantação
 * nenhuma: faltando, a rejeição vem em lote na virada.
 */
export const RACA_COR = [
  { codigo: 1, nome: "Branca" }, { codigo: 2, nome: "Preta" },
  { codigo: 3, nome: "Parda" }, { codigo: 4, nome: "Amarela" },
  { codigo: 5, nome: "Indígena" }, { codigo: 6, nome: "Não informado" },
] as const;

/** Grau de instrução pela tabela 19 do eSocial. */
export const GRAU_INSTRUCAO = [
  { codigo: 1, nome: "Analfabeto" },
  { codigo: 2, nome: "Até o 5º ano incompleto do fundamental" },
  { codigo: 3, nome: "5º ano completo do fundamental" },
  { codigo: 4, nome: "Do 6º ao 9º ano do fundamental incompleto" },
  { codigo: 5, nome: "Fundamental completo" },
  { codigo: 6, nome: "Médio incompleto" },
  { codigo: 7, nome: "Médio completo" },
  { codigo: 8, nome: "Superior incompleto" },
  { codigo: 9, nome: "Superior completo" },
  { codigo: 10, nome: "Pós-graduação completa" },
  { codigo: 11, nome: "Mestrado completo" },
  { codigo: 12, nome: "Doutorado completo" },
] as const;

/**
 * Categorias do eSocial mais usadas, por tipo de vínculo.
 * A tabela completa é dado versionado no banco, carregado por seed: isto aqui
 * é só o atalho da tela de admissão.
 */
export const CATEGORIA_POR_TIPO: Record<string, { codigo: number; nome: string }[]> = {
  clt: [{ codigo: 101, nome: "101 · Empregado geral" },
        { codigo: 103, nome: "103 · Aprendiz" },
        { codigo: 104, nome: "104 · Doméstico" },
        { codigo: 105, nome: "105 · Empregado intermitente" }],
  aprendiz: [{ codigo: 103, nome: "103 · Aprendiz" }],
  intermitente: [{ codigo: 105, nome: "105 · Empregado intermitente" }],
  estagio: [{ codigo: 901, nome: "901 · Estagiário" }],
  autonomo: [{ codigo: 701, nome: "701 · Contribuinte individual, autônomo" }],
  pj: [{ codigo: 701, nome: "701 · Contribuinte individual" }],
  diretor: [{ codigo: 721, nome: "721 · Diretor não empregado, com FGTS" },
            { codigo: 722, nome: "722 · Diretor não empregado, sem FGTS" }],
  terceiro: [{ codigo: 901, nome: "901 · Sem vínculo" }],
};
